import {
  DEFAULT_LOCALE,
  isSupportedLocale,
  SUPPORTED_LOCALES,
  type TSupportedLocale,
} from "libs/i18n/src/lib/locales";
import { setRegionCookie } from "libs/i18n/src/lib/region-cookie";

export const toSupportedLocale = (locale: string): TSupportedLocale => (
  isSupportedLocale(locale) ? locale : DEFAULT_LOCALE
);

/** The current country is listed first, so the preselected option is always at the top. */
export const getLocalesCurrentFirst = (currentLocale: TSupportedLocale): TSupportedLocale[] => [
  currentLocale,
  ...SUPPORTED_LOCALES.filter((locale) => locale !== currentLocale),
];

/**
 * Sets the region cookie and redirects to the locale path (e.g. /de/)
 * which takes priority over the cookie.
 */
export const switchRegionAndReload = (locale: TSupportedLocale): void => {
  setRegionCookie(locale);
  window.location.href = `/${locale}/`;
};
